import { Chip, Tooltip } from "@mui/material";
import { CountText } from "./CountText";
import CommentIcon from '@mui/icons-material/ChatBubbleOutline';

export const CommentChip = ({ count }) => {
    return (
        <Tooltip title="Comments" placement="top" arrow>
            <Chip
                icon={<CommentIcon fontSize="small" />}
                label={<CountText num={count || 0} />}
                size="small"
                variant="outlined"
                aria-label={`${count || 0} comments`}
            />
        </Tooltip>
    );
}